import React from 'react';
import PropTypes from 'prop-types';
import config from '../../../config';

import AdFoxFactory from '../../../ui/AdFox/AdFoxFactory';
import Announcement from '../../../classes/announcement/announcement';
import { getHeaders } from '../../../classes/builder/search/flexListBuilder';

import { Header } from '../../../ui/FlexTable';

class FlexView extends React.Component {
  constructor (props) {
    super(props);

    this.listRef = React.createRef();
    this.ADFOX_LIMIT = 10;
    this.regionName = props.domain.get('domain', '') || '';
  }

  getPureList () {
    const {
      dictionary,
      data,
      user,
      domain,
      onUpdateFilter
    } = this.props;

    const FlexItem = this.props.flexItem;
    return (
        data && data.map((item, index) => {
          const data = new Announcement(item, dictionary);

          return <FlexItem
            key={item.get('id')}
            item={data}
            rawItem={item}
            user={user}
            domain={domain}

            onUpdateFilter={onUpdateFilter}

            eventAddFavorites={this.props.eventAddFavorites}
            eventRemoveFavorites={this.props.eventRemoveFavorites}
            eventAddFavoritesForCian={this.props.eventAddFavoritesForCian}
            eventRemoveFavoritesForCian={this.props.eventRemoveFavoritesForCian}
            eventOpenCommentForm={this.props.eventOpenCommentForm}
            eventOpenClaimForm={this.props.eventOpenClaimForm}
            eventMapModal={this.props.eventMapModal}
            eventShowContacts={this.props.eventShowContacts}
            eventClickAnnouncement={this.props.eventClickAnnouncement}
          />;
        })
    );
  }

  getRealtyList () {
    const realtyList = [];
    const { dealType, realtyType } = this.props;
    const drawAdFox = ((this.props.data.size / this.ADFOX_LIMIT > 1) && config.enableAdFox);
    const hashCode = this.props.data.hashCode();

    this.getPureList().map((item, index) => {
      realtyList.push(item);

      // рекламная строчка после каждого 10 объявления
      if (drawAdFox && ((index + 1) % this.ADFOX_LIMIT === 0)) {
        const position = AdFoxFactory.getListingGridPosition((index + 1) / this.ADFOX_LIMIT);
        const adFoxEl = AdFoxFactory(this.regionName).getBySection(position, dealType, realtyType);

        if (position && adFoxEl) {
          realtyList.push(
            <div className='no-padding no-print' key={position + hashCode}>
              { adFoxEl }
            </div>
          );
        }
      }
    });

    return realtyList;
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    this.listRef.current && this.listRef.current.scrollTo && this.listRef.current.scrollTo(0, 0);
  }

  render () {
    const {
      dealType,
      realtyType,
      sortKey,
      onSort,
      disableSortHeader
    } = this.props;
    return (
      <div className='flex-view-announcement-wrp'>
        { this.props.isLoading &&
          (
            <div className='ajax-waiting-overlay'>
              <div className='radial-progress'>
                <div className='circle'>
                  <div className='fill' />
                </div>
              </div>
            </div>
          )
        }
        <div className='flex-view header'>
          <Header
            sortKey={sortKey}
            onSort={onSort}
            headerList={getHeaders(dealType, realtyType)}
            disableSortHeader={disableSortHeader}
          />
        </div>
        <div className='flex-view flex-view-announcement' ref={this.listRef}>
          <div className='list'>
            { this.getRealtyList() }
          </div>
        </div>
      </div>
    );
  }
}

FlexView.propTypes = {
  flexItem: PropTypes.func.isRequired,
  domain: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,

  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  dealType: PropTypes.string.isRequired,
  realtyType: PropTypes.string.isRequired,

  dictionary: PropTypes.object.isRequired,
  onUpdateFilter: PropTypes.func,

  onSort: PropTypes.func.isRequired,
  sortKey: PropTypes.string,
  disableSortHeader: PropTypes.bool,

  eventAddFavorites: PropTypes.func,
  eventRemoveFavorites: PropTypes.func,
  eventAddFavoritesForCian: PropTypes.func,
  eventRemoveFavoritesForCian: PropTypes.func,
  eventOpenCommentForm: PropTypes.func,
  eventOpenClaimForm: PropTypes.func,
  eventMapModal: PropTypes.func,
  eventShowContacts: PropTypes.func,
  eventClickAnnouncement: PropTypes.func
};

FlexView.defaultProps = {
  onUpdateFilter: () => null,
  sortKey: null,
  disableSortHeader: false,

  eventAddFavorites: id => {},
  eventRemoveFavorites: id => {},
  eventAddFavoritesForCian: id => {},
  eventRemoveFavoritesForCian: id => {},
  eventOpenCommentForm: id => {},
  eventOpenClaimForm: id => {},
  eventMapModal: id => {},
  eventShowContacts: id => {},
  eventClickAnnouncement: id => {}
};

export default FlexView;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/FlexView.jsx